import * as React from 'react';
import EDHighchartsWrapper, { IOptions } from '../EDHighcharts';
import {
  SeriesOptionsType,
  DrilldownEventObject,
  AxisLabelsFormatterContextObject,
  FormatterCallbackFunction,
  Chart,
} from 'highcharts';

interface IProps {
  title?: string;
  yAxisLabel: string;
  formater?: FormatterCallbackFunction<AxisLabelsFormatterContextObject>;
  categories: string[];
  series: SeriesOptionsType[];
  drilldownEvent?: (event: DrilldownEventObject) => void;
  afterChartCreated?: (chart: Chart) => void;
}

/**
 * Stapeldiagram
 */
class EDBarChart extends React.Component<IProps> {
  getData = (): IOptions => {
    const formater = this.props.formater;
    return {
      chart: {
        events: {
          drilldown: this.props.drilldownEvent,
        },
      },
      title: {
        text: this.props.title ? this.props.title : undefined,
      },
      xAxis: {
        categories: this.props.categories,
        type: 'category',
      },
      yAxis: {
        title: {
          text: this.props.yAxisLabel,
        },
        labels: {
          formatter: formater,
        },
      },
      legend: {
        enabled: true,
      },
      series: this.props.series,
      credits: {
        enabled: false,
      },
    };
  };

  render() {
    return (
      <EDHighchartsWrapper
        type="column"
        options={this.getData()}
        afterChartCreated={this.props.afterChartCreated}
      />
    );
  }
}

export default EDBarChart;
